import React from 'react';
import { Helmet } from 'react-helmet-async';
import AuthContainer from '@/components/auth/AuthContainer';
import LoginForm from '@/components/auth/LoginForm';
import translate from '@/lib/intl/translate';
import { useLogin } from './loginPagesHooks';

export default function LoginPage() {
  const { error, loginAction, clearLoginErrors } = useLogin();

  return (
    <AuthContainer size="sm">
      <Helmet>
        <title>{translate('LOGIN')}</title>
      </Helmet>
      <LoginForm
        error={error}
        loginAction={loginAction}
        clearLoginErrors={clearLoginErrors}
      />
    </AuthContainer>
  );
}
